// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__18BNl","inputWrap":"styles_inputWrap__26SZ-","input":"styles_input__2VtEL"};